export interface AnalyticsEvents {
  login: string;
  signUp: string;
  pageView: string;
  purchase: string;
  viewItem: string;
  beginCheckout: string;
  viewCart: string;
  addToCart: string;
  clearCart: string;
  removeFromCart: string;
  addPaymentInfo: string;
  success: string;
  fail: string;
  updated: string;
  deletionModal: string;
  saved: (agentKey: string, key: string) => string;
}

export const analyticsEvents: AnalyticsEvents = {
  login: 'login',
  signUp: 'sign_up',
  pageView: 'page_view',
  purchase: 'purchase',
  viewItem: 'view_item',
  beginCheckout: 'begin_checkout',
  viewCart: 'view_cart',
  addToCart: 'add_to_cart',
  clearCart: 'clear_cart',
  removeFromCart: 'remove_from_cart',
  addPaymentInfo: 'add_payment_info',
  success: 'success',
  fail: 'fail',
  updated: 'updated',
  deletionModal: 'deletion_modal',
  saved: (agentKey, key) => `saved_${agentKey}_${key}`,
};
